import { ReactNode } from "react";
import PageTitle from "../common/PageTitle";
import SearchSummary from "./SearchSummary";
import ToolbarButton from "./ToolbarButton";
import { FilterIcon, MoreHorizontal } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "src/components/shadcn";
import { MenuItem } from "../neighborhoodSearch/savedSearch/ActionsMenu";
import { usePulse, pulseClassName } from "src/hooks/usePulse";

interface MobileSearchPageTitleProps {
  title: string | ReactNode;
  titleIcon?: ReactNode;
  isPro?: boolean;
  totalRecords?: number;
  isLoading?: boolean;
  currentPage?: number;
  pageSize?: number;
  superscriptText?: string;
  subtitle?: string;
  isCondensed?: boolean;
  isUseGutters?: boolean;
  onFiltersClick?: () => void;
  isFiltersSidebarOpen?: boolean;
  actionsMenuItems?: MenuItem[];
  isBatchSelectionActive?: boolean;
}

const MobileSearchPageTitle = ({
  title,
  titleIcon,
  isPro = false,
  totalRecords,
  isLoading = true,
  currentPage,
  pageSize,
  superscriptText,
  subtitle,
  isCondensed,
  isUseGutters,
  onFiltersClick,
  isFiltersSidebarOpen = false,
  actionsMenuItems = [],
  isBatchSelectionActive = false,
}: MobileSearchPageTitleProps) => {
  const isPulsing = usePulse(isBatchSelectionActive);

  const rightSideContent = (
    <div className="flex flex-row items-center gap-2">
      {actionsMenuItems.length > 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <div className={`relative ${pulseClassName(isPulsing)}`}>
              <ToolbarButton
                icon={<MoreHorizontal className="h-5 w-5" />}
              />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="min-w-48">
            {actionsMenuItems.map((item) => (
              <DropdownMenuItem
                key={`${item.type}-${item.label}`}
                className="gap-3 cursor-pointer whitespace-nowrap"
                disabled={item.disabled}
                onClick={() => item.onAction()}
              >
                {item.icon}
                {item.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
      {onFiltersClick && (
        <ToolbarButton
          onClick={onFiltersClick}
          icon={<FilterIcon className="h-5 w-5" />}
          isActive={isFiltersSidebarOpen}
        />
      )}
    </div>
  );

  return (
    <PageTitle
      title={title}
      titleIcon={titleIcon}
      superscriptText={isPro ? "Pro" : superscriptText}
      centerContent={
        <SearchSummary
          isCondensed
          totalRecords={totalRecords}
          pageSize={pageSize}
          currentPage={currentPage}
          isShowing={!isLoading && totalRecords}
        />
      }
      subtitle={subtitle}
      isCondensed={isCondensed}
      isUseGutters={isUseGutters}
      rightSideContent={rightSideContent}
    />
  );
};

export default MobileSearchPageTitle;
